import { fccFlows } from '../../modularReduxComponents/App/constants';

const showFundingAccountBackButton = flow => {
  switch (flow) {
    case 'parent_flow_5':
      return false;
    default:
      return true;
  }
};

const showProgressBarInFlow = flow => fccFlows.indexOf(flow) === -1;

const getFundWalletGroup = flow => {
  switch (flow) {
    case 'parent_flow_1':
      return 'group_5';
    case 'parent_flow_5':
      return 'group_4';
    case 'parent_flow_6':
      return 'group_4';
    case 'parent_flow_7':
      return 'group_2';
    case 'parent_flow_8':
      return 'group_5';
    case 'parent_flow_9':
      return 'group_4';
    case 'parent_flow_10':
      return 'group_5';
    case 'parent_flow_11':
      return 'group_7';
    case 'parent_flow_12':
      return 'group_5';
    case 'parent_flow_13':
      return 'group_6';
    case 'parent_flow_14':
      return 'group_5';
    case 'parent_flow_15':
      return 'group_7';
    case 'parent_flow_16':
    case 'parent_flow_17':
      return 'fund_wallet';
    default:
      return '';
  }
};

const getConfirmIdGroup = flow => {
  switch (flow) {
    case 'parent_flow_1':
      return 'group_4';
    case 'parent_flow_5':
      return 'group_3';
    case 'parent_flow_6':
      return 'group_3';
    case 'parent_flow_7':
      return 'group_4';
    case 'parent_flow_8':
      return 'group_4';
    case 'parent_flow_9':
      return 'group_3';
    case 'parent_flow_10':
      return 'group_4';
    case 'parent_flow_11':
      return 'group_6';
    case 'parent_flow_12':
      return 'group_4';
    case 'parent_flow_13':
      return 'group_5';
    case 'parent_flow_14':
      return 'group_4';
    case 'parent_flow_15':
      return 'group_6';
    case 'parent_flow_16':
      return 'group_5';
    case 'parent_flow_17':
      return 'group_6';
    default:
      return false;
  }
};

const getNoProgressGroups = flow => {
  // Groups that should not be counted in the progress bar(such as prove_prefill standalone and prove_review)
  switch (flow) {
    case 'parent_flow_11':
      return [4, 5];
    case 'parent_flow_12':
      return [3];
    case 'parent_flow_13':
      return [3];
    case 'parent_flow_14':
      return [3];
    case 'parent_flow_15':
      return [4, 5];
    case 'parent_flow_16':
      return [3, 4];
    case 'parent_flow_17':
      return [4, 5];
    default:
      return false;
  }
};

export default {
  showFundingAccountBackButton,
  showProgressBarInFlow,
  getConfirmIdGroup,
  getFundWalletGroup,
  getNoProgressGroups
};
